import type { AxiosInstance } from "axios";

/**
 * Sign up a new merchant. Mirrors `POST /auth/signup` (auth.types.ts `signupBody`).
 *
 * The server ALWAYS answers 200, even for an email that already exists — it silently
 * sends a reset instead of a signup, so this response never reveals whether an address is
 * registered. So the screen's "check your email" message is the same either way, which is
 * the point: enumeration is not possible.
 */
export interface SignupInput {
  readonly email: string;
  readonly name: string;
  readonly password: string;
  readonly orgName?: string;
  readonly orgKind: "brand" | "agency";
}

export async function signup(client: AxiosInstance, input: SignupInput): Promise<void> {
  await client.post("/auth/signup", input);
}
